import React from 'react';
import { FileText, Loader2, Search } from 'lucide-react';
import { formatPrice } from './constants';

function OfferMandateStep({ form, setForm, mandateSearch, setMandateSearch, mandates, mandatesLoading }) {
    const filteredMandates = mandates.filter((m) => {
        if (!mandateSearch) return true;
        const q = mandateSearch.toLowerCase();
        return (
            m.mandate_number?.toLowerCase().includes(q) ||
            m.address?.toLowerCase().includes(q) ||
            m.city?.toLowerCase().includes(q)
        );
    });

    return (
        <div className="space-y-4">
            <p className="text-sm text-white/60">
                Sélectionnez le mandat pour lequel vous souhaitez créer une offre :
            </p>
            <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30 w-4 h-4" />
                <input
                    value={mandateSearch}
                    onChange={(e) => setMandateSearch(e.target.value)}
                    placeholder="Rechercher un mandat..."
                    className="w-full pl-10 pr-4 py-2.5 bg-white/5 border border-white/10 rounded-xl text-white text-sm placeholder:text-white/30 focus:outline-none focus:border-[#681793]/50"
                    data-testid="mandate-search-input"
                />
            </div>
            {mandatesLoading ? (
                <div className="flex justify-center py-8">
                    <Loader2 className="w-6 h-6 animate-spin text-[#FF914D]" />
                </div>
            ) : filteredMandates.length === 0 ? (
                <div className="text-center py-8">
                    <FileText className="w-10 h-10 text-white/20 mx-auto mb-2" />
                    <p className="text-white/40 text-sm">Aucun mandat actif trouvé</p>
                    <p className="text-white/30 text-xs mt-1">
                        Seuls les mandats au statut "Actif" acceptent des offres
                    </p>
                </div>
            ) : (
                <div className="space-y-2 max-h-[40vh] overflow-y-auto">
                    {filteredMandates.map((m) => (
                        <button
                            key={m.id}
                            onClick={() => setForm((f) => ({ ...f, mandate_id: m.id }))}
                            className={`w-full text-left p-3 rounded-xl border transition-all ${
                                form.mandate_id === m.id
                                    ? 'border-[#FF914D]/50 bg-[#FF914D]/10'
                                    : 'border-white/5 bg-white/[0.02] hover:bg-white/5'
                            }`}
                            data-testid={`mandate-option-${m.id}`}
                        >
                            <div className="flex items-center justify-between">
                                <div className="min-w-0">
                                    <p className="font-semibold text-white text-sm truncate">
                                        {m.mandate_number}
                                    </p>
                                    <p className="text-xs text-white/40 truncate">
                                        {m.address}
                                        {m.city ? `, ${m.city}` : ''}
                                    </p>
                                    <p className="text-xs text-white/30 mt-0.5">Agent : {m.agent_name}</p>
                                </div>
                                <div className="text-right shrink-0 ml-3">
                                    <p className="text-sm font-bold text-[#FF914D]">
                                        {formatPrice(m.price)} €
                                    </p>
                                    <p className="text-[10px] text-white/30 capitalize">{m.mandate_type}</p>
                                </div>
                            </div>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}

export default OfferMandateStep;
